module.exports = __webpack_public_path__ + "img/ots.f0f09cfc.png";